const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.78,44S76.83,85.75,36,150.1s-37.64,147,12,208.52S192.59,412,272.08,450.91s167.19,30.91,204.77-51.56S457.77,286.09,448,190.67,352.27-44.49,158.78,44Z",
    style: {
      fill: "#FF0A90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.78,44S76.83,85.75,36,150.1s-37.64,147,12,208.52S192.59,412,272.08,450.91s167.19,30.91,204.77-51.56S457.77,286.09,448,190.67,352.27-44.49,158.78,44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.1,47c1.15,1.93,5.32,4.77,5.33,4.77s1-3.32,1.07-3.53c.45-2.53-.18-7.68-2.72-9a3.4,3.4,0,0,0-4.7,1.88C392.32,43,393.11,45.34,394.1,47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,77.56s2.7-2.2,2.85-2.36c1.77-1.86,4.09-6.5,2.71-9a3.4,3.4,0,0,0-5-1c-1.67,1.14-2.32,3.56-2.41,5.48C433.07,72.88,435,77.56,435,77.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,59.89c1.56,1.5,6,3.06,6.33,3.18a61.9,61.9,0,0,0-2.17,7.74c-.33,1.52-.61,3.07-.88,4.63,0-.73,0-1.38,0-1.47-.24-2.56-2.2-7.36-5-8a3.41,3.41,0,0,0-4,3.05c-.23,2,1.16,4.1,2.54,5.42S389,77.21,390,77.57c-.1.6-.2,1.19-.29,1.79-.45,2.87-.89,5.74-1.4,8.54-.18,1-.39,1.95-.6,2.92,0-.65,0-1.2,0-1.28-.24-2.55-2.2-7.35-5-8a3.41,3.41,0,0,0-4,3.06c-.24,2,1.16,4.09,2.54,5.42s4.79,2.61,6,3c-.25,1-.49,2-.77,2.91-.21.64-.37,1.27-.61,1.9s-.45,1.25-.68,1.86c-.47,1.17-.95,2.39-1.45,3.52-.33.79-.67,1.53-1,2.28.19-1,.52-2.9.53-3.07.16-2.56-1.06-7.6-3.74-8.64A3.4,3.4,0,0,0,375,96.25c-.54,2,.52,4.22,1.69,5.74,1.28,1.67,5.25,3.81,5.74,4.08-.56,1.24-1.11,2.44-1.65,3.57-1.57,3.28-3,6-4.17,8.15l1.57,1.12c1.13-2.19,2.58-5.09,4.14-8.55.57-1.26,1.16-2.62,1.75-4a35.51,35.51,0,0,0,4.27.78c.27,2.16,2.26,5.87,2.52,6.34-1.15.73-2.28,1.43-3.35,2.07-3.06,1.83-5.75,3.32-7.85,4.44l1.7,1.22c2-1.12,4.36-2.52,7-4.21,1.17-.73,2.41-1.54,3.67-2.39.38.41,3.45,3.71,5.4,4.53,1.77.75,4.23,1.2,6,.19a3.41,3.41,0,0,0,1.21-4.92c-1.69-2.33-6.87-2.23-9.31-1.44-.15,0-1.65.73-2.59,1.18l1.54-1c1-.71,2.06-1.45,3.16-2.25l1.57-1.21c.53-.4,1.05-.88,1.58-1.33,1.2-1,2.37-2.17,3.53-3.33.62.91,2.89,4.12,4.53,5.13s4,1.82,5.89,1.08a3.4,3.4,0,0,0,1.93-4.68c-1.31-2.56-6.45-3.24-9-2.83-.16,0-1.94.53-2.92.83.69-.7,1.38-1.4,2.05-2.13,1.95-2.12,3.85-4.32,5.76-6.5.58-.67,1.17-1.33,1.76-2,.22.33,2.84,4.2,4.67,5.33,1.64,1,4,1.82,5.89,1.08a3.41,3.41,0,0,0,1.94-4.68c-1.32-2.55-6.46-3.24-9-2.82-.19,0-2.76.75-3.4,1,1.3-1.46,2.6-2.9,3.94-4.27A59.52,59.52,0,0,1,424,84.26c.1.15,2.81,4.2,4.69,5.36,1.64,1,4,1.82,5.89,1.08A3.39,3.39,0,0,0,436.46,86c-1.31-2.56-6.45-3.25-9-2.83-.17,0-2.12.58-3.05.86l-.07-.14A44.34,44.34,0,0,1,431,79.8c1.28-.66,2.53-1.22,3.77-1.74.43.81,2.42,4.47,4,5.7s3.77,2.25,5.73,1.72a3.39,3.39,0,0,0,2.44-4.43c-1-2.69-6.06-3.94-8.62-3.8-.14,0-1.55.24-2.57.42.56-.22,1.13-.47,1.67-.67,2-.78,3.94-1.36,5.64-1.86,1-.28,1.84-.52,2.66-.73.84.58,4.22,2.84,6.15,3.2s4.38.26,5.88-1.11a3.41,3.41,0,0,0,.12-5.07c-2.15-1.91-7.19-.7-9.4.61-.19.11-3,2.21-2.94,2.24l.05,0c-.79.18-1.65.39-2.57.64-1.71.46-3.64,1-5.69,1.74a61.46,61.46,0,0,0-6.53,2.68,44.83,44.83,0,0,0-6.79,4s-.05,0-.08.06c.5-.68,1.84-2.62,1.93-2.78,1.21-2.26,2.22-7.35.22-9.42a3.4,3.4,0,0,0-5.05.32c-1.31,1.55-1.29,4.05-.87,5.93.47,2.1,3.31,5.84,3.53,6.14a61.72,61.72,0,0,0-6.08,5.25q-1.67,1.65-3.29,3.38c.42-.6.79-1.13.83-1.22,1.21-2.26,2.22-7.34.22-9.41a3.4,3.4,0,0,0-5.05.32C409,83.51,409,86,409.44,87.88s2.78,5.13,3.41,6l-1.23,1.34c-2,2.14-3.9,4.29-5.88,6.35-.69.72-1.4,1.41-2.11,2.1.37-.54.67-1,.71-1.06,1.21-2.27,2.22-7.35.23-9.42a3.42,3.42,0,0,0-5.06.32c-1.31,1.55-1.29,4.05-.87,5.92s2.55,4.82,3.3,5.83c-.75.69-1.49,1.37-2.25,2-.52.42-1,.86-1.55,1.25l-1.59,1.18c-1.05.72-2.12,1.46-3.15,2.14-.71.47-1.41.91-2.1,1.35.7-.71,2-2.14,2.14-2.27a13.19,13.19,0,0,0,2.29-6.26,3.27,3.27,0,0,0,.4-.64,3.39,3.39,0,0,0-1.71-4.76c-2.69-1-6.95,1.93-8.55,3.94-.1.11-1,1.52-1.51,2.41.23-.57.47-1.13.71-1.72.47-1.17.92-2.35,1.4-3.62l.63-1.88c.23-.62.39-1.31.59-2,.42-1.54.78-3.13,1.1-4.73,1,.41,4.69,1.84,6.61,1.77s4.34-.68,5.51-2.34a3.4,3.4,0,0,0-1-5c-2.51-1.41-7.17.85-9.06,2.6-.12.11-1.33,1.51-2,2.29.19-1,.38-1.92.54-2.91.46-2.83.83-5.72,1.21-8.59.12-.88.25-1.76.37-2.64.37.15,4.68,1.94,6.84,1.87,1.91-.07,4.34-.69,5.51-2.35a3.4,3.4,0,0,0-1-5c-2.51-1.41-7.17.86-9.06,2.6-.14.13-1.88,2.16-2.29,2.69.27-1.93.56-3.86.93-5.74a59.25,59.25,0,0,1,1.93-7.53c.17.07,4.66,2,6.87,1.88,1.91-.07,4.34-.68,5.51-2.34a3.4,3.4,0,0,0-1-5c-2.51-1.41-7.17.85-9.05,2.6-.13.11-1.46,1.65-2.07,2.4l-.14-.08a43.67,43.67,0,0,1,3.27-7.1c.7-1.25,1.44-2.42,2.18-3.53.8.44,4.49,2.39,6.48,2.54s4.39-.2,5.73-1.72a3.39,3.39,0,0,0-.41-5c-2.34-1.68-7.22.06-9.29,1.58-.11.09-1.15,1.06-1.91,1.78.35-.5.69-1,1-1.49,1.27-1.77,2.54-3.31,3.67-4.66.65-.77,1.26-1.45,1.83-2.08,1,0,5.08,0,6.89-.72s3.8-2.2,4.29-4.17A3.4,3.4,0,0,0,415.14,34c-2.85-.41-6.38,3.38-7.51,5.69-.1.2-1.27,3.49-1.21,3.49h.06c-.57.6-1.16,1.24-1.8,2-1.17,1.33-2.47,2.84-3.78,4.59a58,58,0,0,0-4,5.83,44,44,0,0,0-3.46,7.09l0,.09c0-.84.09-3.19.07-3.37-.24-2.56-2.2-7.36-5-8a3.4,3.4,0,0,0-4,3C384.24,56.49,385.63,58.57,387,59.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,88.83c2.11-.77,5.67-4.35,5.67-4.35s-3.07-1.64-3.27-1.71c-2.41-.91-7.58-1.24-9.37,1a3.39,3.39,0,0,0,1,5C307.38,89.84,309.86,89.5,311.66,88.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.25,54.29c.05,0-1.66-3-1.79-3.23-1.5-2.08-5.63-5.22-8.37-4.33a3.41,3.41,0,0,0-1.92,4.69c.82,1.86,3.08,2.93,4.94,3.37C344.3,55.31,349.25,54.29,349.25,54.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,98.17c1.76-1.25,4.11-5.31,4.29-5.64a58.92,58.92,0,0,0,7.21,3.56c1.44.61,2.91,1.18,4.39,1.72-.72-.15-1.35-.27-1.44-.28-2.56-.24-7.64.8-8.77,3.45a3.4,3.4,0,0,0,2.26,4.53c1.93.6,4.23-.38,5.79-1.5s3.65-4.55,4.19-5.46l1.71.62c2.74,1,5.47,1.92,8.13,2.94.94.36,1.85.75,2.76,1.14-.64-.14-1.17-.24-1.25-.25-2.56-.24-7.64.8-8.77,3.45a3.4,3.4,0,0,0,2.26,4.53c1.93.61,4.23-.38,5.79-1.49s3.45-4.22,4.09-5.31c.92.43,1.85.85,2.72,1.3.59.32,1.18.59,1.75.94l1.71,1c1.07.69,2.17,1.38,3.19,2.08.71.47,1.38.94,2.06,1.41-.93-.37-2.76-1.06-2.92-1.1-2.49-.62-7.67-.36-9.19,2.09a3.4,3.4,0,0,0,1.55,4.82c1.82.89,4.24.26,5.95-.6,1.89-.95,4.72-4.46,5.07-4.9,1.12.78,2.2,1.55,3.21,2.29,2.93,2.15,5.38,4.08,7.24,5.6l1.39-1.33c-1.94-1.52-4.53-3.48-7.64-5.66-1.13-.79-2.36-1.62-3.62-2.45a36.71,36.71,0,0,0,1.55-4.06c2.17.13,6.18-1.13,6.7-1.3.5,1.27,1,2.5,1.41,3.67,1.24,3.35,2.2,6.26,2.91,8.54l1.51-1.45c-.73-2.15-1.67-4.75-2.83-7.69-.51-1.29-1.07-2.66-1.67-4,.47-.3,4.29-2.71,5.45-4.48,1.06-1.6,2-3.93,1.28-5.84a3.4,3.4,0,0,0-4.61-2.09c-2.6,1.22-3.45,6.34-3.12,8.88,0,.15.41,1.76.67,2.77-.24-.57-.47-1.13-.73-1.71-.51-1.16-1.05-2.3-1.63-3.52-.3-.59-.6-1.18-.91-1.77s-.67-1.19-1-1.79q-1.23-2.07-2.63-4.09c1-.45,4.58-2.08,5.88-3.51s2.53-3.59,2.15-5.58a3.4,3.4,0,0,0-4.24-2.77c-2.76.82-4.38,5.74-4.44,8.31,0,.16.16,2,.27,3-.56-.81-1.12-1.62-1.71-2.41-1.72-2.31-3.53-4.58-5.33-6.86l-1.63-2.1c.36-.16,4.64-2,6.09-3.61,1.29-1.42,2.53-3.59,2.15-5.58a3.4,3.4,0,0,0-4.24-2.77c-2.75.82-4.38,5.74-4.43,8.31,0,.19.23,2.85.33,3.52-1.2-1.54-2.38-3.09-3.48-4.67a60.07,60.07,0,0,1-4.06-6.62c.17-.07,4.65-2,6.13-3.63,1.29-1.42,2.54-3.59,2.16-5.58a3.41,3.41,0,0,0-4.24-2.77c-2.76.82-4.38,5.75-4.44,8.31,0,.17.18,2.19.29,3.15l-.16,0a43.35,43.35,0,0,1-2.82-7.29c-.41-1.37-.73-2.71-1-4,.87-.27,4.84-1.56,6.33-2.88s2.91-3.29,2.76-5.32a3.4,3.4,0,0,0-3.91-3.21c-2.83.51-5,5.23-5.33,7.77,0,.14-.05,1.57-.06,2.61-.11-.6-.25-1.21-.35-1.78-.38-2.14-.61-4.12-.79-5.88-.09-1-.16-1.9-.21-2.75.71-.71,3.56-3.62,4.27-5.45s1.06-4.27,0-6a3.39,3.39,0,0,0-5-1c-2.28,1.76-2,6.93-1.15,9.35.08.21,1.63,3.34,1.67,3.3l0,0c0,.82.08,1.69.16,2.65.14,1.76.32,3.76.66,5.91a61.35,61.35,0,0,0,1.43,6.91A44.33,44.33,0,0,0,353,66.17a.35.35,0,0,0,.05.08c-.58-.62-2.23-2.29-2.38-2.41-2-1.6-6.81-3.54-9.21-2a3.41,3.41,0,0,0-.62,5c1.28,1.57,3.74,2,5.66,2,2.16-.08,6.36-2.17,6.69-2.34a60.49,60.49,0,0,0,4,7c.87,1.3,1.79,2.58,2.72,3.85l-1-1c-2-1.61-6.81-3.54-9.21-2a3.4,3.4,0,0,0-.62,5c1.28,1.58,3.74,2,5.66,2s5.56-1.79,6.51-2.25l1.08,1.45c1.75,2.32,3.51,4.63,5.16,6.95.58.82,1.12,1.64,1.67,2.46-.45-.46-.84-.84-.91-.89-2-1.61-6.81-3.54-9.21-2a3.4,3.4,0,0,0-.62,5c1.29,1.58,3.75,2,5.66,2s5.21-1.62,6.34-2.17c.53.86,1.07,1.72,1.55,2.58.31.59.66,1.14.94,1.75s.58,1.2.87,1.79c.51,1.16,1,2.34,1.51,3.48.33.79.64,1.55.94,2.32-.57-.82-1.72-2.4-1.83-2.52a13.16,13.16,0,0,0-5.73-3.41,3.78,3.78,0,0,0-.55-.51,3.39,3.39,0,0,0-5,.8c-1.49,2.45.61,7.19,2.29,9.13.1.12,1.31,1.24,2.09,1.93l-1.56-1c-1.06-.69-2.14-1.34-3.29-2l-1.74-1c-.57-.34-1.21-.62-1.83-.94-1.43-.7-2.92-1.34-4.44-2,.6-.93,2.67-4.26,3-6.17s.14-4.39-1.28-5.84a3.39,3.39,0,0,0-5.06,0c-1.85,2.2-.49,7.2.88,9.38.08.13,1.24,1.58,1.89,2.37-.91-.37-1.82-.73-2.76-1.07-2.7-1-5.47-1.87-8.22-2.78l-2.53-.85c.22-.33,2.77-4.24,3.1-6.37.29-1.9.13-4.39-1.29-5.85a3.41,3.41,0,0,0-5.06,0c-1.85,2.21-.49,7.21.88,9.38.1.17,1.77,2.25,2.22,2.76-1.85-.63-3.69-1.27-5.47-2a60.73,60.73,0,0,1-7-3.28c.11-.16,2.79-4.22,3.12-6.41.29-1.89.13-4.39-1.28-5.84a3.4,3.4,0,0,0-5.07,0c-1.84,2.2-.48,7.2.89,9.38.08.14,1.35,1.73,2,2.47l-.1.12A43.33,43.33,0,0,1,321,87.28c-1.11-.92-2.11-1.86-3.07-2.8.58-.71,3.18-4,3.7-5.9s.61-4.35-.64-6a3.39,3.39,0,0,0-5-.52c-2.08,2-1.27,7.11-.16,9.42.07.12.83,1.33,1.39,2.2-.42-.43-.87-.86-1.27-1.28-1.5-1.57-2.78-3.1-3.9-4.47-.63-.78-1.19-1.5-1.7-2.18.2-1,1-5,.55-6.9s-1.46-4.15-3.3-5a3.39,3.39,0,0,0-4.71,1.85c-.93,2.72,2.14,6.9,4.2,8.43.18.14,3.2,1.89,3.21,1.84V76c.48.66,1,1.37,1.59,2.12,1.1,1.4,2.34,3,3.82,4.57a60.27,60.27,0,0,0,5,5A44.49,44.49,0,0,0,327,92.34l.08,0c-.81-.2-3.12-.69-3.3-.7-2.56-.24-7.64.8-8.77,3.45a3.41,3.41,0,0,0,2.26,4.53C319.18,100.27,321.47,99.29,323,98.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,376.92c1.74.6,4.71,3.46,4.71,3.46s-2.48,1.39-2.65,1.46c-1.94.78-6.16,1.14-7.66-.67a2.78,2.78,0,0,1,.71-4.07C136.58,376.17,138.61,376.41,140.09,376.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.38,404.49c.05,0-1.3,2.53-1.4,2.68-1.2,1.72-4.52,4.35-6.76,3.67a2.77,2.77,0,0,1-1.65-3.79c.63-1.53,2.46-2.45,4-2.85C167.33,403.75,171.38,404.49,171.38,404.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,369.1c1.46,1,3.45,4.27,3.6,4.53a50.86,50.86,0,0,1,5.83-3c1.16-.52,2.35-1,3.55-1.48-.58.14-1.1.25-1.17.26-2.08.24-6.25-.53-7.22-2.66a2.77,2.77,0,0,1,1.77-3.74c1.57-.53,3.46.23,4.76,1.12s3.06,3.65,3.51,4.39l1.38-.53c2.22-.84,4.44-1.67,6.6-2.55.76-.31,1.49-.64,2.23-1l-1,.22c-2.08.24-6.25-.53-7.22-2.67a2.78,2.78,0,0,1,1.77-3.74c1.57-.52,3.46.24,4.76,1.13s2.89,3.38,3.43,4.26c.74-.36,1.49-.72,2.2-1.11.47-.27,1-.5,1.41-.8l1.38-.85c.86-.58,1.74-1.17,2.57-1.75l1.66-1.19c-.76.32-2.24.91-2.37.94-2,.55-6.26.43-7.54-1.54a2.78,2.78,0,0,1,1.18-4c1.48-.76,3.46-.29,4.88.38s3.93,3.56,4.22,3.92c.9-.66,1.77-1.3,2.58-1.93,2.36-1.8,4.32-3.42,5.82-4.69l1.16,1.06c-1.56,1.27-3.64,2.92-6.15,4.75-.91.67-1.9,1.36-2.92,2.07a28.59,28.59,0,0,1,1.34,3.28,20.73,20.73,0,0,1,5.49.95c.39-1,.76-2.06,1.09-3,1-2.76,1.69-5.15,2.24-7l1.26,1.16c-.56,1.76-1.29,3.91-2.19,6.33-.39,1.06-.83,2.18-1.29,3.33.39.23,3.55,2.14,4.53,3.56s1.67,3.18,1.15,4.75a2.78,2.78,0,0,1-3.73,1.79c-2.15-.95-2.94-5.12-2.71-7.2,0-.12.31-1.44.51-2.27L193,366c-.39.95-.81,1.89-1.26,2.9-.24.48-.48,1-.71,1.46s-.53,1-.8,1.48c-.64,1.14-1.34,2.27-2.07,3.38.83.35,3.78,1.63,4.86,2.77s2.12,2.89,1.85,4.52a2.78,2.78,0,0,1-3.42,2.34c-2.26-.62-3.67-4.62-3.76-6.71,0-.13.09-1.65.17-2.47-.45.66-.89,1.33-1.36,2-1.37,1.91-2.81,3.8-4.24,5.69-.43.58-.86,1.17-1.3,1.75.3.12,3.83,1.56,5,2.84s2.13,2.89,1.86,4.53a2.78,2.78,0,0,1-3.42,2.33c-2.26-.62-3.67-4.62-3.76-6.71,0-.16.14-2.33.21-2.89-1,1.28-1.89,2.57-2.76,3.87a48.09,48.09,0,0,0-3.21,5.49c.14.05,3.83,1.54,5.07,2.85,1.08,1.14,2.13,2.89,1.86,4.52a2.79,2.79,0,0,1-3.42,2.34c-2.26-.62-3.67-4.62-3.76-6.71,0-.14.1-1.8.18-2.58l-.13,0a36,36,0,0,0-2.18,6c-.31,1.13-.55,2.23-.76,3.31.72.2,4,1.18,5.23,2.24s2.43,2.64,2.33,4.29a2.78,2.78,0,0,1-3.13,2.7c-2.32-.37-4.16-4.19-4.49-6.26,0-.11-.06-1.28-.09-2.13-.08.49-.18,1-.26,1.46-.27,1.75-.42,3.37-.54,4.81-.06.82-.1,1.56-.13,2.26.6.57,3,2.89,3.58,4.38s.94,3.46.1,4.88a2.79,2.79,0,0,1-4,.95c-1.89-1.4-1.76-5.63-1.09-7.62.06-.17,1.27-2.75,1.3-2.72l0,0c0-.67,0-1.38.08-2.17.08-1.44.2-3.07.44-4.84a48.61,48.61,0,0,1,1-5.66,36.64,36.64,0,0,1,2.06-6.11.43.43,0,0,0,0-.07c-.46.52-1.78,1.91-1.9,2-1.61,1.35-5.5,3-7.49,1.76a2.79,2.79,0,0,1-.59-4.1c1-1.31,3-1.71,4.59-1.69,1.76,0,5.23,1.67,5.5,1.8a48,48,0,0,1,3.19-5.74c.68-1.08,1.41-2.14,2.15-3.2-.41.43-.78.82-.84.86-1.61,1.35-5.5,3-7.49,1.76a2.78,2.78,0,0,1-.59-4.09c1-1.31,3-1.71,4.59-1.69s4.57,1.36,5.35,1.72l.86-1.2c1.39-1.93,2.78-3.84,4.09-5.76.47-.68.9-1.36,1.33-2.05-.36.39-.67.71-.73.75-1.6,1.35-5.5,3-7.49,1.76a2.79,2.79,0,0,1-.59-4.1c1-1.3,3-1.71,4.59-1.69a17.83,17.83,0,0,1,5.21,1.67c.42-.72.85-1.43,1.23-2.14.24-.49.51-.94.73-1.45s.46-1,.68-1.47c.4-.95.82-1.93,1.18-2.87.26-.65.49-1.28.73-1.91-.45.68-1.37,2-1.45,2.09a10.73,10.73,0,0,1-4.62,2.88,3.64,3.64,0,0,1-.45.43,2.78,2.78,0,0,1-4.1-.57c-1.26-2,.38-5.88,1.72-7.5.08-.09,1.05-1,1.68-1.61l-1.26.86c-.85.57-1.73,1.12-2.66,1.72l-1.4.83c-.46.28-1,.52-1.47.79-1.17.6-2.37,1.15-3.6,1.68.5.75,2.25,3.44,2.52,5s.19,3.58-.95,4.79a2.77,2.77,0,0,1-4.13.06c-1.55-1.76-.52-5.87.56-7.67.07-.11,1-1.32,1.5-2-.74.31-1.47.63-2.23.92-2.19.84-4.44,1.62-6.67,2.41l-2.05.74c.18.26,2.33,3.41,2.64,5.15.27,1.54.18,3.58-1,4.8a2.79,2.79,0,0,1-4.14.06c-1.54-1.77-.52-5.88.56-7.68.08-.13,1.41-1.86,1.77-2.29-1.5.55-3,1.1-4.44,1.71a47.73,47.73,0,0,0-5.69,2.8c.08.13,2.34,3.4,2.65,5.18.27,1.55.18,3.59-1,4.8a2.79,2.79,0,0,1-4.14.06c-1.54-1.77-.51-5.88.57-7.68.07-.11,1.08-1.43,1.57-2.05l-.09-.1A35,35,0,0,0,147.7,378c-.88.77-1.69,1.55-2.45,2.33.48.57,2.66,3.19,3.12,4.76s.57,3.54-.42,4.87a2.77,2.77,0,0,1-4.1.51c-1.73-1.59-1.16-5.78-.29-7.69.05-.1.65-1.1,1.1-1.82-.34.35-.7.72-1,1.07-1.2,1.31-2.22,2.58-3.11,3.71-.5.65-.95,1.25-1.35,1.81.18.81.88,4.06.57,5.63s-1.12,3.41-2.62,4.13a2.78,2.78,0,0,1-3.88-1.43c-.8-2.21,1.64-5.67,3.29-7,.15-.11,2.58-1.6,2.59-1.55l0,0c.38-.55.79-1.13,1.26-1.76.87-1.16,1.86-2.45,3-3.79a47.89,47.89,0,0,1,4-4.15,36.18,36.18,0,0,1,5.09-3.95l.06,0c-.66.18-2.54.61-2.68.63-2.09.23-6.25-.53-7.22-2.67a2.78,2.78,0,0,1,1.77-3.74C146,367.45,147.93,368.22,149.22,369.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.53,390.24c1.71-.67,5.83-.43,5.83-.43s-1,2.67-1.07,2.83c-1,1.85-3.94,4.87-6.25,4.47a2.78,2.78,0,0,1-2.11-3.56C193.38,392,195.07,390.82,196.53,390.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.23,390.85s.65,2.76.67,2.94c.22,2.09-.6,6.25-2.75,7.19a2.78,2.78,0,0,1-3.72-1.81c-.51-1.58.28-3.46,1.18-4.74C234.66,392.92,238.23,390.85,238.23,390.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,378.36c1.75-.19,5.39,1,5.68,1.11a48.12,48.12,0,0,1,2.45-6.09c.55-1.15,1.14-2.3,1.74-3.44-.35.48-.67.91-.72,1-1.43,1.54-5.09,3.66-7.22,2.67a2.78,2.78,0,0,1-1.09-4c.85-1.43,2.79-2.07,4.35-2.24s4.7.78,5.52,1.05l.71-1.31c1.14-2.08,2.29-4.15,3.35-6.22.38-.72.72-1.45,1.07-2.18l-.63.83c-1.43,1.53-5.09,3.66-7.22,2.66a2.78,2.78,0,0,1-1.09-4c.85-1.42,2.79-2.07,4.35-2.24s4.39.7,5.37,1c.33-.76.67-1.52,1-2.27.19-.52.4-1,.56-1.53s.33-1,.49-1.55c.28-1,.57-2,.82-3,.17-.68.33-1.33.48-2-.36.73-1.11,2.14-1.18,2.25-1.18,1.74-4.48,4.39-6.73,3.73a2.78,2.78,0,0,1-1.68-3.78c.62-1.53,2.44-2.47,3.95-2.87,1.67-.45,5.3.15,5.76.22.25-1.08.49-2.13.71-3.13.62-2.91,1.06-5.42,1.37-7.36l1.57.06c-.36,2-.87,4.58-1.59,7.6-.25,1.1-.55,2.27-.87,3.47a30.79,30.79,0,0,1,3.16,1.63,20.24,20.24,0,0,1,4.78-2.85c-.38-1.05-.76-2.06-1.13-3-1.07-2.71-2.07-5-2.87-6.78l1.71.06c.72,1.7,1.57,3.8,2.46,6.23.39,1.06.79,2.2,1.18,3.37.45-.08,4.09-.68,5.76-.24,1.51.4,3.33,1.33,4,2.87a2.78,2.78,0,0,1-1.67,3.78c-2.26.67-5.56-2-6.74-3.71-.07-.11-.71-1.3-1.09-2.06.16.48.32.95.47,1.45.32,1,.62,2,.93,3,.14.51.27,1,.41,1.57s.24,1.09.36,1.64c.25,1.28.45,2.59.62,3.92.86-.28,3.93-1.23,5.49-1.06s3.5.81,4.35,2.23a2.79,2.79,0,0,1-1.08,4c-2.12,1-5.79-1.12-7.22-2.65-.09-.1-1-1.32-1.48-2,.1.79.2,1.59.27,2.4.2,2.34.34,4.71.48,7.08,0,.72.1,1.44.15,2.17.3-.11,3.92-1.31,5.67-1.12,1.56.17,3.5.81,4.35,2.23a2.79,2.79,0,0,1-1.08,4c-2.12,1-5.79-1.12-7.22-2.66-.11-.11-1.41-1.86-1.72-2.32.11,1.59.24,3.17.42,4.73a51.2,51.2,0,0,0,1.13,6.25c.14-.05,3.92-1.32,5.71-1.13,1.56.17,3.5.81,4.35,2.24a2.77,2.77,0,0,1-1.08,4c-2.12,1-5.79-1.12-7.22-2.65-.1-.1-1.09-1.44-1.54-2.08l-.12.06a34.83,34.83,0,0,0,2.24,6c.5,1.07,1,2,1.57,3,.68-.31,3.8-1.69,5.43-1.69s3.57.42,4.57,1.74a2.77,2.77,0,0,1-.63,4.08c-2,1.23-5.88-.47-7.47-1.84-.09-.07-.89-.92-1.46-1.55.25.42.5.87.75,1.27.93,1.51,1.87,2.84,2.72,4,.48.66.94,1.25,1.36,1.8.83,0,4.15.27,5.57,1s3,2,3.25,3.65a2.77,2.77,0,0,1-2.44,3.33c-2.34.17-5-3.13-5.78-5.07-.07-.17-.83-2.92-.79-2.92h.05c-.42-.52-.87-1.07-1.34-1.7-.88-1.15-1.85-2.46-2.82-4a51.86,51.86,0,0,1-2.88-5,36.57,36.57,0,0,1-2.4-6s0-.05,0-.08c0,.69-.11,2.61-.14,2.76-.34,2.07-2.22,5.86-4.55,6.21a2.79,2.79,0,0,1-3.11-2.73c-.07-1.66,1.19-3.27,2.39-4.27,1.36-1.13,5.06-2.13,5.35-2.21a48.79,48.79,0,0,1-1.31-6.43c-.18-1.27-.32-2.55-.44-3.83,0,.6-.07,1.13-.08,1.2-.34,2.07-2.23,5.86-4.55,6.21a2.79,2.79,0,0,1-3.11-2.73c-.07-1.66,1.18-3.27,2.39-4.27s4.36-1.93,5.19-2.17c0-.49-.09-1-.13-1.47-.2-2.37-.38-4.73-.64-7-.09-.82-.2-1.62-.32-2.42,0,.53,0,1-.06,1-.35,2.07-2.23,5.87-4.55,6.21a2.78,2.78,0,0,1-3.11-2.73c-.08-1.65,1.18-3.26,2.39-4.26s4-1.85,5-2.13c-.15-.82-.29-1.63-.46-2.42-.13-.53-.22-1.05-.38-1.58l-.45-1.56c-.31-1-.63-2-1-2.95-.22-.66-.45-1.29-.68-1.92.1.81.25,2.4.25,2.53a10.83,10.83,0,0,1-1.63,5.2,4.22,4.22,0,0,1-.07.61,2.77,2.77,0,0,1-3.48,2.23c-2.24-.68-3.54-4.71-3.57-6.81,0-.13.13-1.47.22-2.32-.13.49-.25,1-.39,1.47-.28,1-.58,2-.9,3-.17.51-.35,1-.53,1.53s-.4,1.05-.6,1.57c-.5,1.21-1.05,2.41-1.64,3.61.87.25,3.94,1.15,5.16,2.15s2.47,2.61,2.39,4.26a2.78,2.78,0,0,1-3.1,2.74c-2.32-.34-4.21-4.13-4.56-6.2,0-.13-.11-1.64-.14-2.47-.36.72-.71,1.44-1.1,2.15-1.12,2.06-2.32,4.12-3.5,6.17-.37.63-.72,1.26-1.08,1.89.31.08,4,1.08,5.35,2.2,1.21,1,2.47,2.61,2.4,4.26a2.79,2.79,0,0,1-3.1,2.74c-2.33-.34-4.22-4.13-4.57-6.2,0-.16-.14-2.33-.14-2.89-.79,1.39-1.56,2.78-2.26,4.18a48.22,48.22,0,0,0-2.51,5.84c.14,0,4,1.06,5.38,2.21,1.21,1,2.47,2.6,2.4,4.26a2.77,2.77,0,0,1-3.1,2.73c-2.33-.33-4.22-4.13-4.57-6.19,0-.14-.11-1.8-.14-2.59l-.13,0a36.84,36.84,0,0,0-1.42,6.23c-.17,1.16-.27,2.28-.35,3.37.74.12,4.1.69,5.46,1.59s2.74,2.31,2.85,4a2.78,2.78,0,0,1-2.78,3.06c-2.35-.08-4.64-3.64-5.22-5.66,0-.11-.22-1.26-.35-2.1,0,.49-.06,1-.08,1.47-.06,1.78,0,3.41.05,4.85,0,.82.1,1.56.15,2.25.67.49,3.31,2.51,4.1,3.91s1.36,3.32.69,4.84a2.78,2.78,0,0,1-3.88,1.43c-2-1.15-2.44-5.37-2-7.43,0-.17.92-2.88,1-2.86l0,0c-.07-.67-.13-1.38-.19-2.16-.09-1.44-.18-3.08-.15-4.86a47.09,47.09,0,0,1,.34-5.75,36.33,36.33,0,0,1,1.3-6.31.24.24,0,0,0,0-.08c-.39.57-1.53,2.12-1.63,2.23-1.43,1.53-5.09,3.66-7.22,2.66a2.78,2.78,0,0,1-1.09-4C194.89,379.18,196.83,378.53,198.39,378.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 482,
    rx: 214,
    ry: 8,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.86,
    y: 124.29,
    width: 328.99,
    height: 239.91,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.86,
    y: 124.29,
    width: 328.99,
    height: 17.08,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.54,
    y: 70.07,
    width: 53.48,
    height: 34.91,
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.22,
    y: 70.07,
    width: 53.48,
    height: 34.91,
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.34 89.38 175.34 70.07 121.86 70.07 121.86 89.38 121.86 104.98 121.86 124.29 450.86 124.29 450.86 89.38 175.34 89.38",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,192.61v.17h-.66v-.2c0-.57-.22-.9-.72-.9s-.72.33-.72.89c0,1.41,2.11,1.54,2.11,3.31,0,1-.46,1.57-1.42,1.57s-1.4-.62-1.4-1.57v-.36h.65v.39c0,.57.23.9.74.9s.73-.33.73-.9c0-1.4-2.1-1.53-2.1-3.3,0-1,.45-1.57,1.39-1.57S139,191.66,139,192.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,195.9c0,.57.23.91.74.91s.73-.34.73-.91v-4.8h.65v4.77c0,.95-.44,1.59-1.41,1.59s-1.4-.64-1.4-1.59V191.1h.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.08,197.37h-.67l-1-5v5h-.61V191.1h1l1,5,1-5h1v6.28h-.67v-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,192.62c0-1,.48-1.58,1.44-1.58s1.44.62,1.44,1.58v3.25c0,.95-.47,1.58-1.44,1.58a1.38,1.38,0,0,1-1.44-1.58Zm.69,3.28c0,.58.24.91.75.91s.74-.33.74-.91v-3.32c0-.56-.23-.9-.74-.9s-.75.34-.75.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,197.38v-5.64h-1.16v-.64h3v.64h-1.16v5.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,195.9c0,.57.23.91.74.91s.73-.34.73-.91v-4.8h.65v4.77c0,.95-.44,1.59-1.41,1.59s-1.4-.64-1.4-1.59V191.1h.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,197.38h-1L195,191.1h.68l.74,5.35.7-5.34h.69l.69,5.35.71-5.36h.61l-.85,6.28H198l-.6-4.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.59,193.89v.62h-1.54v2.24h1.89v.63h-2.59V191.1h2.59v.64h-1.89v2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.45,197.38v-5.64h-1.16v-.64h3v.64h-1.16v5.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.47,194.56v2.82h-.7V191.1h.7v2.83H224V191.1h.7v6.28H224v-2.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.11,194v.64h-1.45v2.71H241V191.1h2.49v.64h-1.8V194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41,191.1c1,0,1.4.51,1.4,1.44v.51c0,.69-.24,1.12-.78,1.29.58.17.79.64.79,1.31v1a1.5,1.5,0,0,0,.13.75h-.71a1.64,1.64,0,0,1-.12-.76v-1c0-.7-.33-.93-.91-.93h-.5v2.68H244V191.1Zm-.18,3c.56,0,.89-.17.89-.86v-.6c0-.56-.2-.86-.72-.86h-.69v2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6,192.61v.17h-.67v-.2c0-.57-.21-.9-.71-.9s-.72.33-.72.89c0,1.41,2.11,1.54,2.11,3.31,0,1-.46,1.57-1.42,1.57s-1.41-.62-1.41-1.57v-.36h.66v.39c0,.57.23.9.73.9s.74-.33.74-.9c0-1.4-2.1-1.53-2.1-3.3,0-1,.45-1.57,1.39-1.57S268.6,191.66,268.6,192.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,196.12l-.25,1.26H269l1.2-6.28h1l1.21,6.28h-.7l-.25-1.26Zm.09-.6h1.39l-.7-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.2,
    y: 163.16,
    width: 54.99,
    height: 14.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.78 170.43 174.51 175.97 174.51 164.88 171.78 170.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.93 170.43 236.19 175.97 236.19 164.88 238.93 170.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.16,173.26h.4c.52,0,.84-.28.84-1v-5.45h.79v5.4c0,1.34-.67,1.76-1.53,1.78a2.75,2.75,0,0,1-.5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.79,172.54l-.28,1.44h-.74l1.37-7.17h1.16l1.38,7.17h-.8l-.28-1.44Zm.1-.69h1.6l-.81-4.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,174h-.72v-7.17h1L200,172v-5.19h.7V174h-.83l-1.83-5.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.25,172.29c0,.65.26,1,.84,1s.83-.39.83-1v-5.48h.75v5.44c0,1.09-.5,1.82-1.61,1.82s-1.6-.73-1.6-1.82v-5.44h.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.27,172.54,206,174h-.73l1.37-7.17h1.16l1.37,7.17h-.8l-.28-1.44Zm.1-.69H208l-.81-4.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,166.81c1.12,0,1.59.57,1.59,1.64V169c0,.79-.27,1.29-.89,1.48.66.19.9.73.9,1.5v1.11a1.7,1.7,0,0,0,.15.86h-.81a1.88,1.88,0,0,1-.13-.87V172c0-.81-.38-1.07-1-1.07h-.56V174h-.8v-7.17Zm-.21,3.38c.64,0,1-.2,1-1v-.69c0-.64-.24-1-.84-1h-.77v2.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,171.41l-1.51-4.6h.83l1.11,3.53,1.13-3.53h.76l-1.53,4.6V174H215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.75,
    cy: 260.44,
    r: 8.03,
    style: {
      fill: "#FF0A90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,214.93a1.94,1.94,0,0,1-.87.27v-.58a1.07,1.07,0,0,0,1.07-.83h.49v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.71,215.31c0,1.9-2.13,2.58-2.14,4v.1h2.06v.64h-2.75v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.6,1.41-1.6S268.71,214.35,268.71,215.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11,237.25v.16a1.48,1.48,0,0,0,0,2.59v.48c0,1-.44,1.59-1.41,1.59s-1.41-.63-1.41-1.59v-.43h.65v.48c0,.56.24.9.74.9s.73-.33.73-1V240c0-.62-.26-.91-.79-.93h-.37v-.63h.41a.75.75,0,0,0,.75-.86v-.29c0-.64-.22-1-.73-1s-.74.34-.74.91v.32h-.65v-.28c0-1,.45-1.58,1.41-1.58S139.11,236.29,139.11,237.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.31,240.74V242h-.68v-1.27h-2v-.63l2-4.38h.76v4.38h.5v.63Zm-2.06-.63h1.38V237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.89,238.29a1,1,0,0,1,.93-.52c.81,0,1.17.59,1.17,1.49v1.22c0,1-.46,1.59-1.42,1.59s-1.41-.63-1.41-1.59v-.42h.66v.47c0,.56.23.9.74.9s.73-.34.73-.9v-1.22c0-.57-.23-.91-.73-.91a.68.68,0,0,0-.71.68v.14h-.66l.17-3.49h2.48v.63H176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.94,237.24v.11h-.66v-.16c0-.56-.23-.89-.74-.89s-.76.34-.76,1v1.41a1,1,0,0,1,1-.68c.81,0,1.17.59,1.17,1.49v.95c0,1-.48,1.59-1.44,1.59s-1.44-.63-1.44-1.59v-3.2c0-1,.45-1.61,1.44-1.61S197.94,236.28,197.94,237.24Zm-2.16,2.35v.94c0,.56.23.9.74.9s.75-.34.75-.9v-.94c0-.57-.25-.91-.75-.91S195.78,239,195.78,239.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.63,236.36H218.5v-.63h2.84v.61L219.73,242H219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.84,237.22v.2a1.24,1.24,0,0,1-.71,1.29,1.27,1.27,0,0,1,.71,1.33v.46a1.48,1.48,0,1,1-3,0V240a1.26,1.26,0,0,1,.72-1.33,1.23,1.23,0,0,1-.72-1.29v-.2a1.48,1.48,0,1,1,3,0Zm-2.26,0v.3c0,.61.29.88.78.88s.79-.27.79-.88v-.3c0-.65-.29-.94-.79-.94S241.58,236.59,241.58,237.24Zm0,2.71v.53c0,.65.28,1,.78,1s.79-.3.79-1V240c0-.6-.26-.9-.79-.9S241.58,239.35,241.58,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.7,237.25v3.2c0,1-.45,1.62-1.46,1.62s-1.41-.62-1.41-1.58v-.11h.65v.16c0,.56.24.89.75.89s.77-.34.77-1V239a1,1,0,0,1-1,.67c-.8,0-1.16-.58-1.16-1.48v-1c0-1,.46-1.58,1.43-1.58S268.7,236.29,268.7,237.25Zm-2.19,0v.94c0,.57.24.91.74.91s.75-.34.75-.91v-.94c0-.57-.24-.91-.75-.91S266.51,236.64,266.51,237.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.61,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.3,259.19c0-1,.48-1.58,1.44-1.58s1.44.62,1.44,1.58v3.24c0,1-.47,1.58-1.44,1.58s-1.44-.62-1.44-1.58Zm.69,3.28c0,.57.24.91.75.91s.74-.34.74-.91v-3.32c0-.57-.23-.91-.74-.91s-.75.34-.75.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.05,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.47,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.05,259.2c0,1.89-2.13,2.57-2.14,4v.1H181V264h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.64-.22-1-.74-1s-.73.37-.73.92v.56h-.66v-.51c0-1,.44-1.6,1.41-1.6S181.05,258.24,181.05,259.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,258.81a1.79,1.79,0,0,1-.87.27v-.57a1.08,1.08,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.94,259.19v.16a1.48,1.48,0,0,0,0,2.59v.49c0,1-.45,1.58-1.41,1.58s-1.41-.62-1.41-1.58V262h.65v.47c0,.57.24.91.74.91s.73-.33.73-1v-.49c0-.61-.26-.91-.79-.93h-.37v-.63h.41c.47,0,.75-.31.75-.86v-.28c0-.65-.22-1-.73-1s-.74.35-.74.91v.33h-.65v-.29c0-1,.45-1.58,1.41-1.58S200.94,258.23,200.94,259.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.82,258.81a1.79,1.79,0,0,1-.87.27v-.57a1.08,1.08,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,262.69V264h-.68v-1.26h-2v-.64l2-4.38h.76v4.38h.5v.64Zm-2.06-.64h1.38V259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7,260.23a1,1,0,0,1,.93-.52c.81,0,1.17.59,1.17,1.49v1.23c0,1-.46,1.58-1.42,1.58s-1.41-.62-1.41-1.58V262h.65v.46c0,.57.24.91.74.91s.73-.34.73-.91v-1.22c0-.56-.23-.9-.73-.9a.67.67,0,0,0-.71.67v.14H244l.17-3.49h2.47v.63h-1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.16,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.73,259.18v.12h-.66v-.16c0-.57-.23-.9-.74-.9s-.76.34-.76,1v1.41a1,1,0,0,1,1-.67c.81,0,1.17.58,1.17,1.49v.95c0,1-.48,1.58-1.44,1.58s-1.44-.62-1.44-1.58v-3.21c0-1,.44-1.61,1.44-1.61S271.73,258.22,271.73,259.18Zm-2.16,2.35v.94c0,.57.23.91.74.91s.75-.34.75-.91v-.94c0-.56-.25-.91-.75-.91S269.57,261,269.57,261.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.61,280.76a1.85,1.85,0,0,1-.87.26v-.57a1.07,1.07,0,0,0,1.07-.83h.49v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,280.24h-2.14v-.62h2.84v.61l-1.61,5.67h-.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.05,280.76a1.85,1.85,0,0,1-.87.26v-.57a1.07,1.07,0,0,0,1.07-.83h.49v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,281.1v.2a1.23,1.23,0,0,1-.71,1.29,1.27,1.27,0,0,1,.71,1.33v.47a1.48,1.48,0,1,1-3,0v-.47a1.27,1.27,0,0,1,.73-1.33,1.22,1.22,0,0,1-.73-1.29v-.2a1.48,1.48,0,1,1,3,0Zm-2.26,0v.31c0,.61.29.88.78.88s.79-.27.79-.88v-.31c0-.64-.29-.94-.79-.94S157.41,280.48,157.41,281.12Zm0,2.72v.53c0,.65.28.95.78.95s.79-.3.79-.95v-.53c0-.61-.26-.91-.79-.91S157.41,283.23,157.41,283.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.47,280.76a1.82,1.82,0,0,1-.87.26v-.57a1.08,1.08,0,0,0,1.08-.83h.48v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,281.13v3.2c0,1-.45,1.63-1.45,1.63s-1.42-.62-1.42-1.58v-.12h.65v.16c0,.57.25.9.75.9s.77-.34.77-1v-1.41a1,1,0,0,1-1,.66c-.81,0-1.17-.57-1.17-1.48v-1c0-1,.47-1.58,1.43-1.58S181,280.17,181,281.13Zm-2.19,0V282c0,.56.24.9.74.9s.75-.34.75-.9v-.94c0-.58-.23-.91-.75-.91S178.85,280.52,178.85,281.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,281.14c0,1.89-2.13,2.58-2.14,4v.1h2.07v.64h-2.76v-.54c0-2,2.13-2.43,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.92v.56h-.66v-.51c0-1,.44-1.6,1.41-1.6S198,280.18,198,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,281.13c0-1,.48-1.58,1.44-1.58s1.44.62,1.44,1.58v3.24c0,1-.48,1.59-1.44,1.59s-1.44-.63-1.44-1.59Zm.69,3.28c0,.57.24.91.75.91s.74-.34.74-.91V281.1c0-.58-.23-.92-.74-.92s-.75.34-.75.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,281.14c0,1.89-2.13,2.58-2.14,4v.1h2.07v.64h-2.76v-.54c0-2,2.13-2.43,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.92v.56h-.66v-.51c0-1,.44-1.6,1.41-1.6S221.37,280.18,221.37,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,280.76a1.85,1.85,0,0,1-.87.26v-.57a1.07,1.07,0,0,0,1.07-.83H224v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,281.14c0,1.89-2.13,2.58-2.13,4v.1h2.06v.64H241v-.54c0-2,2.13-2.43,2.13-4.19,0-.65-.21-1-.73-1s-.74.37-.74.92v.56H241v-.51c0-1,.44-1.6,1.41-1.6S243.79,280.18,243.79,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.26,281.14c0,1.89-2.13,2.58-2.13,4v.1h2.06v.64h-2.75v-.54c0-2,2.12-2.43,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.92v.56h-.65v-.51c0-1,.43-1.6,1.4-1.6S247.26,280.18,247.26,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.71,281.14c0,1.89-2.13,2.58-2.14,4v.1h2.06v.64h-2.75v-.54c0-2,2.13-2.43,2.13-4.19,0-.65-.22-1-.74-1s-.74.37-.74.92v.56h-.65v-.51c0-1,.44-1.6,1.41-1.6S268.71,280.18,268.71,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.14,281.13v.16a1.26,1.26,0,0,1-.76,1.3,1.24,1.24,0,0,1,.76,1.3v.48c0,1-.45,1.59-1.42,1.59s-1.41-.63-1.41-1.59v-.43H270v.47c0,.57.23.91.73.91s.74-.33.74-1v-.48c0-.62-.26-.92-.79-.94h-.38v-.62h.42a.76.76,0,0,0,.75-.86v-.29c0-.65-.22-1-.74-1s-.73.35-.73.92v.32h-.66v-.29c0-1,.45-1.58,1.41-1.58S272.14,280.17,272.14,281.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,303.08c0,1.9-2.13,2.58-2.14,4v.1h2.07v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S139.15,302.12,139.15,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34,306.57v1.27h-.68v-1.27h-2v-.63l2-4.38h.76v4.38h.5v.63Zm-2.06-.63h1.38v-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,303.08c0,1.9-2.13,2.58-2.13,4v.1h2.06v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.21-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S156.59,302.12,156.59,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,304.11a1,1,0,0,1,.93-.51c.81,0,1.16.59,1.16,1.48v1.23c0,1-.45,1.59-1.41,1.59s-1.41-.63-1.41-1.59v-.42h.65v.47c0,.56.24.9.74.9s.73-.34.73-.9v-1.22c0-.57-.23-.91-.73-.91a.68.68,0,0,0-.71.67v.15h-.65l.17-3.49h2.47v.63H158Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,303.08c0,1.9-2.13,2.58-2.14,4v.1h2.06v.64h-2.75v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S178,302.12,178,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.48,303.07v.11h-.66V303c0-.56-.23-.9-.74-.9s-.76.34-.76,1v1.41a1,1,0,0,1,1-.68c.81,0,1.17.59,1.17,1.49v.95c0,1-.48,1.59-1.44,1.59s-1.44-.63-1.44-1.59v-3.2c0-1,.45-1.61,1.44-1.61S181.48,302.11,181.48,303.07Zm-2.16,2.35v.94c0,.56.23.9.74.9s.75-.34.75-.9v-.94c0-.57-.25-.91-.75-.91S179.32,304.85,179.32,305.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,303.08c0,1.9-2.13,2.58-2.14,4v.1h2.07v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S198,302.12,198,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.68,302.19h-2.13v-.63h2.84v.61l-1.61,5.67h-.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,303.08c0,1.9-2.13,2.58-2.14,4v.1h2.07v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S221.37,302.12,221.37,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.89,303.05v.19a1.24,1.24,0,0,1-.72,1.3,1.27,1.27,0,0,1,.72,1.32v.47a1.48,1.48,0,1,1-3,0v-.47a1.26,1.26,0,0,1,.73-1.32,1.24,1.24,0,0,1-.73-1.3v-.19a1.48,1.48,0,1,1,3,0Zm-2.27,0v.3c0,.61.3.88.79.88s.79-.27.79-.88v-.3c0-.65-.29-.95-.79-.95S222.62,302.42,222.62,303.07Zm0,2.71v.53c0,.65.29.95.79.95s.78-.3.79-.95v-.53c0-.61-.27-.9-.79-.9S222.62,305.17,222.62,305.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,303.08c0,1.9-2.13,2.58-2.13,4v.1h2.06v.64H241v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.21-1-.73-1s-.74.37-.74.93v.55H241v-.51c0-1,.44-1.59,1.41-1.59S243.79,302.12,243.79,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,303.07v3.21c0,1-.45,1.62-1.45,1.62s-1.42-.62-1.42-1.58v-.11H245v.16c0,.56.24.89.74.89s.77-.34.77-1v-1.41a1,1,0,0,1-1,.66c-.81,0-1.17-.57-1.17-1.48v-1c0-1,.47-1.57,1.44-1.57S247.25,302.11,247.25,303.07Zm-2.19,0V304c0,.57.25.91.75.91s.74-.34.74-.91V303c0-.58-.23-.91-.74-.91S245.06,302.46,245.06,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,303.07v.17a1.48,1.48,0,0,0,0,2.59v.48c0,1-.45,1.59-1.42,1.59s-1.41-.63-1.41-1.59v-.43h.66v.48c0,.56.23.9.73.9s.74-.33.74-1v-.48c0-.62-.26-.91-.79-.93h-.38v-.63h.42a.75.75,0,0,0,.75-.86v-.29c0-.64-.22-1-.74-1s-.73.35-.73.92v.32h-.66v-.29c0-1,.45-1.57,1.41-1.57S268.67,302.11,268.67,303.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3,303.07c0-1,.47-1.57,1.43-1.57a1.37,1.37,0,0,1,1.45,1.57v3.24c0,1-.48,1.59-1.45,1.59s-1.43-.63-1.43-1.59Zm.69,3.29c0,.56.24.9.74.9s.75-.34.75-.9V303c0-.58-.24-.92-.75-.92s-.74.34-.74.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11,325v.16a1.48,1.48,0,0,0,0,2.59v.49c0,1-.44,1.58-1.41,1.58s-1.41-.62-1.41-1.58v-.43h.65v.47c0,.57.24.91.74.91s.73-.34.73-1v-.49c0-.62-.26-.91-.79-.93h-.37v-.63h.41c.47,0,.75-.31.75-.86V325c0-.64-.22-1-.73-1s-.74.35-.74.91v.32h-.65V325c0-1,.45-1.58,1.41-1.58S139.11,324.06,139.11,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,324.64a2,2,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.94,192.61v.17h-.67v-.2c0-.57-.21-.9-.72-.9s-.71.33-.71.89c0,1.41,2.1,1.54,2.1,3.31,0,1-.45,1.57-1.41,1.57s-1.41-.62-1.41-1.57v-.36h.65v.39c0,.57.24.9.74.9s.74-.33.74-.9c0-1.4-2.1-1.53-2.1-3.3,0-1,.44-1.57,1.39-1.57S294.94,191.66,294.94,192.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.22,195.9c0,.57.22.91.73.91s.73-.34.73-.91v-4.8h.66v4.77c0,.95-.44,1.59-1.41,1.59s-1.4-.64-1.4-1.59V191.1h.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,197.37h-.67l-1-5v5h-.61V191.1h1l1,5,1-5h1v6.28H313v-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3,192.62c0-1,.47-1.58,1.43-1.58s1.44.62,1.44,1.58v3.25c0,.95-.47,1.58-1.44,1.58s-1.43-.63-1.43-1.58Zm.69,3.28c0,.58.24.91.74.91s.75-.33.75-.91v-3.32c0-.56-.24-.9-.75-.9s-.74.34-.74.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,197.38v-5.64h-1.16v-.64h3v.64h-1.16v5.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,195.9c0,.57.22.91.73.91s.73-.34.73-.91v-4.8h.65v4.77c0,.95-.44,1.59-1.4,1.59s-1.4-.64-1.4-1.59V191.1H335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,197.38h-1l-.86-6.28h.69l.73,5.35.7-5.34h.69l.69,5.35.71-5.36h.61l-.85,6.28h-.93l-.6-4.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.48,193.89v.62h-1.54v2.24h1.89v.63h-2.58V191.1h2.58v.64h-1.89v2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,197.38v-5.64h-1.16v-.64h3v.64H376v5.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.36,194.56v2.82h-.7V191.1h.7v2.83h1.55V191.1h.7v6.28h-.7v-2.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,194v.64h-1.44v2.71h-.7V191.1h2.49v.64h-1.79V194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.31,191.1c1,0,1.4.51,1.4,1.44v.51a1.18,1.18,0,0,1-.78,1.29c.57.17.79.64.79,1.31v1a1.63,1.63,0,0,0,.12.75h-.71a1.67,1.67,0,0,1-.11-.76v-1c0-.7-.33-.93-.92-.93h-.49v2.68h-.7V191.1Zm-.18,3c.56,0,.89-.17.89-.86v-.6c0-.56-.21-.86-.73-.86h-.68v2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.49,192.61v.17h-.66v-.2c0-.57-.22-.9-.72-.9s-.72.33-.72.89c0,1.41,2.11,1.54,2.11,3.31,0,1-.46,1.57-1.42,1.57s-1.4-.62-1.4-1.57v-.36h.65v.39c0,.57.23.9.74.9s.73-.33.73-.9c0-1.4-2.1-1.53-2.1-3.3,0-1,.45-1.57,1.39-1.57S424.49,191.66,424.49,192.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.82,196.12l-.24,1.26h-.65l1.2-6.28h1l1.2,6.28h-.7l-.24-1.26Zm.09-.6h1.4l-.71-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.96,
    y: 163.16,
    width: 54.99,
    height: 14.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.54 170.43 329.27 175.97 329.27 164.88 326.54 170.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.69 170.43 390.95 175.97 390.95 164.88 393.69 170.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.91,173.26h.4c.53,0,.84-.28.84-1v-5.45h.79v5.4c0,1.34-.66,1.76-1.52,1.78a2.88,2.88,0,0,1-.51,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.54,172.54l-.27,1.44h-.74l1.37-7.17h1.16l1.37,7.17h-.8l-.27-1.44Zm.11-.69h1.59l-.81-4.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.77,174h-.72v-7.17h1l1.66,5.19v-5.19h.71V174h-.83l-1.83-5.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,172.29c0,.65.26,1,.84,1s.83-.39.83-1v-5.48h.75v5.44c0,1.09-.5,1.82-1.61,1.82s-1.6-.73-1.6-1.82v-5.44H357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,172.54l-.28,1.44H360l1.38-7.17h1.15l1.38,7.17h-.8l-.28-1.44Zm.1-.69h1.6l-.81-4.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.14,166.81c1.13,0,1.6.57,1.6,1.64V169c0,.79-.28,1.29-.89,1.48.66.19.9.73.9,1.5v1.11a1.81,1.81,0,0,0,.14.86h-.8a1.72,1.72,0,0,1-.14-.87V172c0-.81-.38-1.07-1-1.07h-.57V174h-.8v-7.17Zm-.2,3.38c.63,0,1-.2,1-1v-.69c0-.64-.23-1-.83-1h-.78v2.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.75,171.41l-1.52-4.6h.83l1.12,3.53,1.13-3.53h.76l-1.53,4.6V174h-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.91,
    cy: 305.01,
    r: 8.03,
    transform: "translate(-112.02 339.59) rotate(-45)",
    style: {
      fill: "#FF0A90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.14,214.93a1.94,1.94,0,0,1-.87.27v-.58a1.08,1.08,0,0,0,1.08-.83h.48v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.6,215.31c0,1.9-2.13,2.58-2.13,4v.1h2.06v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.6,1.41-1.6S424.6,214.35,424.6,215.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,237.25v.16a1.48,1.48,0,0,0,0,2.59v.48c0,1-.45,1.59-1.42,1.59s-1.41-.63-1.41-1.59v-.43h.66v.48c0,.56.23.9.73.9s.74-.33.74-1V240c0-.62-.26-.91-.79-.93h-.38v-.63h.41a.75.75,0,0,0,.76-.86v-.29c0-.64-.23-1-.74-1s-.73.34-.73.91v.32h-.66v-.28c0-1,.45-1.58,1.41-1.58S295,236.29,295,237.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.21,240.74V242h-.69v-1.27h-2v-.63l1.94-4.38h.77v4.38h.5v.63Zm-2.07-.63h1.38V237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78,238.29a1,1,0,0,1,.94-.52c.8,0,1.16.59,1.16,1.49v1.22c0,1-.45,1.59-1.41,1.59s-1.41-.63-1.41-1.59v-.42h.65v.47c0,.56.24.9.74.9s.73-.34.73-.9v-1.22c0-.57-.23-.91-.73-.91a.68.68,0,0,0-.71.68v.14h-.66l.17-3.49h2.48v.63h-1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,237.24v.11h-.65v-.16c0-.56-.24-.89-.75-.89s-.76.34-.76,1v1.41a1,1,0,0,1,1-.68c.81,0,1.17.59,1.17,1.49v.95c0,1-.48,1.59-1.44,1.59s-1.44-.63-1.44-1.59v-3.2c0-1,.45-1.61,1.44-1.61S353.83,236.28,353.83,237.24Zm-2.16,2.35v.94c0,.56.23.9.74.9s.75-.34.75-.9v-.94c0-.57-.24-.91-.75-.91S351.67,239,351.67,239.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.53,236.36h-2.14v-.63h2.84v.61L375.62,242h-.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74,237.22v.2a1.25,1.25,0,0,1-.72,1.29,1.27,1.27,0,0,1,.72,1.33v.46a1.48,1.48,0,1,1-3,0V240a1.27,1.27,0,0,1,.72-1.33,1.23,1.23,0,0,1-.72-1.29v-.2a1.48,1.48,0,1,1,3,0Zm-2.27,0v.3c0,.61.29.88.79.88s.79-.27.79-.88v-.3c0-.65-.3-.94-.79-.94S397.47,236.59,397.47,237.24Zm0,2.71v.53c0,.65.29,1,.79,1s.78-.3.79-1V240c0-.6-.27-.9-.79-.9S397.47,239.35,397.47,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,237.25v3.2c0,1-.45,1.62-1.45,1.62s-1.42-.62-1.42-1.58v-.11h.65v.16c0,.56.25.89.75.89s.77-.34.77-1V239a1,1,0,0,1-1,.67c-.81,0-1.17-.58-1.17-1.48v-1c0-1,.47-1.58,1.44-1.58S424.59,236.29,424.59,237.25Zm-2.19,0v.94c0,.57.24.91.75.91s.74-.34.74-.91v-.94c0-.57-.23-.91-.74-.91S422.4,236.64,422.4,237.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,259.19c0-1,.48-1.58,1.44-1.58s1.44.62,1.44,1.58v3.24c0,1-.47,1.58-1.44,1.58s-1.44-.62-1.44-1.58Zm.7,3.28c0,.57.24.91.74.91s.74-.34.74-.91v-3.32c0-.57-.23-.91-.74-.91s-.74.34-.74.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.94,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48V264H314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.37,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.94,259.2c0,1.89-2.12,2.57-2.13,4v.1h2.06V264h-2.75v-.54c0-2,2.12-2.42,2.12-4.19,0-.64-.21-1-.73-1s-.74.37-.74.92v.56h-.65v-.51c0-1,.44-1.6,1.4-1.6S336.94,258.24,336.94,259.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84H353V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.84,259.19v.16a1.47,1.47,0,0,0,0,2.59v.49c0,1-.45,1.58-1.42,1.58s-1.41-.62-1.41-1.58V262h.66v.47c0,.57.23.91.73.91s.74-.33.74-1v-.49c0-.61-.26-.91-.79-.93H355v-.63h.41a.75.75,0,0,0,.76-.86v-.28c0-.65-.23-1-.74-1s-.73.35-.73.91v.33H354v-.29c0-1,.45-1.58,1.41-1.58S356.84,258.23,356.84,259.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,262.69V264h-.68v-1.26h-2v-.64l1.94-4.38H380v4.38h.51v.64Zm-2.06-.64h1.38V259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.14,258.81a1.82,1.82,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.59,260.23a1,1,0,0,1,.93-.52c.81,0,1.17.59,1.17,1.49v1.23c0,1-.46,1.58-1.42,1.58s-1.41-.62-1.41-1.58V262h.66v.46c0,.57.23.91.73.91s.74-.34.74-.91v-1.22c0-.56-.23-.9-.74-.9a.68.68,0,0,0-.71.67v.14h-.65l.17-3.49h2.48v.63h-1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.06,258.81a1.86,1.86,0,0,1-.87.27v-.57a1.07,1.07,0,0,0,1.07-.84h.49V264h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.62,259.18v.12H427v-.16c0-.57-.24-.9-.75-.9s-.76.34-.76,1v1.41a1,1,0,0,1,1-.67c.81,0,1.17.58,1.17,1.49v.95c0,1-.48,1.58-1.44,1.58s-1.44-.62-1.44-1.58v-3.21c0-1,.45-1.61,1.44-1.61S427.62,258.22,427.62,259.18Zm-2.16,2.35v.94c0,.57.23.91.74.91s.75-.34.75-.91v-.94c0-.56-.24-.91-.75-.91S425.46,261,425.46,261.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,280.76a1.82,1.82,0,0,1-.87.26v-.57a1.08,1.08,0,0,0,1.08-.83h.48v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.34,280.24H295.2v-.62h2.85v.61l-1.62,5.67h-.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.94,280.76a1.82,1.82,0,0,1-.87.26v-.57a1.08,1.08,0,0,0,1.08-.83h.48v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.57,281.1v.2a1.23,1.23,0,0,1-.72,1.29,1.28,1.28,0,0,1,.72,1.33v.47a1.48,1.48,0,1,1-3,0v-.47a1.28,1.28,0,0,1,.72-1.33,1.21,1.21,0,0,1-.72-1.29v-.2a1.48,1.48,0,1,1,3,0Zm-2.27,0v.31c0,.61.29.88.79.88s.79-.27.79-.88v-.31c0-.64-.3-.94-.79-.94S313.3,280.48,313.3,281.12Zm0,2.72v.53c0,.65.29.95.79.95s.78-.3.79-.95v-.53c0-.61-.27-.91-.79-.91S313.3,283.23,313.3,283.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.37,280.76a1.85,1.85,0,0,1-.87.26v-.57a1.07,1.07,0,0,0,1.07-.83h.49v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,281.13v3.2c0,1-.45,1.63-1.45,1.63s-1.42-.62-1.42-1.58v-.12h.66v.16c0,.57.24.9.74.9s.77-.34.77-1v-1.41a1,1,0,0,1-1,.66c-.81,0-1.17-.57-1.17-1.48v-1c0-1,.47-1.58,1.44-1.58S336.93,280.17,336.93,281.13Zm-2.19,0V282c0,.56.25.9.75.9s.74-.34.74-.9v-.94c0-.58-.23-.91-.74-.91S334.74,280.52,334.74,281.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,281.14c0,1.89-2.12,2.58-2.13,4v.1h2.06v.64H351v-.54c0-2,2.12-2.43,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.92v.56H351v-.51c0-1,.44-1.6,1.4-1.6S353.84,280.18,353.84,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,281.13c0-1,.48-1.58,1.44-1.58s1.44.62,1.44,1.58v3.24c0,1-.47,1.59-1.44,1.59s-1.44-.63-1.44-1.59Zm.69,3.28c0,.57.25.91.75.91s.74-.34.74-.91V281.1c0-.58-.23-.92-.74-.92s-.75.34-.75.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.26,281.14c0,1.89-2.13,2.58-2.13,4v.1h2.06v.64h-2.76v-.54c0-2,2.13-2.43,2.13-4.19,0-.65-.21-1-.73-1s-.74.37-.74.92v.56h-.66v-.51c0-1,.44-1.6,1.41-1.6S377.26,280.18,377.26,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.19,280.76a1.82,1.82,0,0,1-.87.26v-.57a1.09,1.09,0,0,0,1.08-.83h.48v6.28h-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,281.14c0,1.89-2.12,2.58-2.13,4v.1h2.06v.64h-2.75v-.54c0-2,2.12-2.43,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.92v.56h-.65v-.51c0-1,.44-1.6,1.41-1.6S399.68,280.18,399.68,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,281.14c0,1.89-2.12,2.58-2.13,4v.1h2.06v.64h-2.75v-.54c0-2,2.12-2.43,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.92v.56h-.65v-.51c0-1,.44-1.6,1.41-1.6S403.15,280.18,403.15,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.6,281.14c0,1.89-2.13,2.58-2.14,4v.1h2.07v.64h-2.76v-.54c0-2,2.13-2.43,2.13-4.19,0-.65-.22-1-.74-1s-.73.37-.73.92v.56h-.66v-.51c0-1,.44-1.6,1.41-1.6S424.6,280.18,424.6,281.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,281.13v.16a1.26,1.26,0,0,1-.76,1.3,1.24,1.24,0,0,1,.76,1.3v.48c0,1-.44,1.59-1.41,1.59s-1.41-.63-1.41-1.59v-.43h.65v.47c0,.57.24.91.74.91s.73-.33.73-1v-.48c0-.62-.26-.92-.79-.94h-.37v-.62h.41a.75.75,0,0,0,.75-.86v-.29c0-.65-.22-1-.73-1s-.74.35-.74.92v.32h-.65v-.29c0-1,.45-1.58,1.41-1.58S428,280.17,428,281.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,303.08c0,1.9-2.12,2.58-2.13,4v.1H295v.64h-2.75v-.54c0-2,2.12-2.42,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.93v.55h-.65v-.51c0-1,.44-1.59,1.41-1.59S295,302.12,295,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.24,306.57v1.27h-.69v-1.27h-2v-.63l1.94-4.38h.77v4.38h.5v.63Zm-2.07-.63h1.38v-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,303.08c0,1.9-2.12,2.58-2.13,4v.1h2.06v.64h-2.75v-.54c0-2,2.12-2.42,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.93v.55h-.65v-.51c0-1,.44-1.59,1.41-1.59S312.48,302.12,312.48,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,304.11a1,1,0,0,1,.93-.51c.81,0,1.17.59,1.17,1.48v1.23c0,1-.46,1.59-1.42,1.59s-1.41-.63-1.41-1.59v-.42h.66v.47c0,.56.23.9.73.9s.74-.34.74-.9v-1.22c0-.57-.24-.91-.74-.91a.69.69,0,0,0-.71.67v.15h-.65l.17-3.49h2.48v.63h-1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.91,303.08c0,1.9-2.13,2.58-2.13,4v.1h2.06v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.21-1-.74-1s-.73.37-.73.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S333.91,302.12,333.91,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.37,303.07v.11h-.65V303c0-.56-.24-.9-.75-.9s-.76.34-.76,1v1.41a1,1,0,0,1,1-.68c.81,0,1.17.59,1.17,1.49v.95c0,1-.48,1.59-1.44,1.59s-1.44-.63-1.44-1.59v-3.2c0-1,.45-1.61,1.44-1.61S337.37,302.11,337.37,303.07Zm-2.16,2.35v.94c0,.56.23.9.74.9s.75-.34.75-.9v-.94c0-.57-.24-.91-.75-.91S335.21,304.85,335.21,305.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,303.08c0,1.9-2.12,2.58-2.13,4v.1h2.06v.64H351v-.54c0-2,2.12-2.42,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.93v.55H351v-.51c0-1,.44-1.59,1.4-1.59S353.84,302.12,353.84,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.58,302.19h-2.14v-.63h2.85v.61l-1.62,5.67H355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.26,303.08c0,1.9-2.13,2.58-2.13,4v.1h2.06v.64h-2.76v-.54c0-2,2.13-2.42,2.13-4.19,0-.65-.21-1-.73-1s-.74.37-.74.93v.55h-.66v-.51c0-1,.44-1.59,1.41-1.59S377.26,302.12,377.26,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,303.05v.19a1.55,1.55,0,0,0,0,2.62v.47a1.48,1.48,0,1,1-3,0v-.47a1.25,1.25,0,0,1,.72-1.32,1.24,1.24,0,0,1-.72-1.3v-.19a1.48,1.48,0,1,1,3,0Zm-2.27,0v.3c0,.61.29.88.79.88s.78-.27.78-.88v-.3c0-.65-.29-.95-.78-.95S378.52,302.42,378.52,303.07Zm0,2.71v.53c0,.65.28.95.79.95s.78-.3.78-.95v-.53c0-.61-.26-.9-.78-.9S378.52,305.17,378.52,305.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,303.08c0,1.9-2.12,2.58-2.13,4v.1h2.06v.64h-2.75v-.54c0-2,2.12-2.42,2.12-4.19,0-.65-.21-1-.73-1s-.74.37-.74.93v.55h-.65v-.51c0-1,.44-1.59,1.41-1.59S399.68,302.12,399.68,303.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,303.07v3.21c0,1-.45,1.62-1.46,1.62s-1.42-.62-1.42-1.58v-.11h.66v.16c0,.56.24.89.74.89s.78-.34.78-1v-1.41a1,1,0,0,1-1,.66c-.8,0-1.16-.57-1.16-1.48v-1c0-1,.46-1.57,1.43-1.57A1.37,1.37,0,0,1,403.15,303.07ZM401,303V304c0,.57.24.91.74.91s.75-.34.75-.91V303c0-.58-.24-.91-.75-.91S401,302.46,401,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56,303.07v.17a1.48,1.48,0,0,0,0,2.59v.48c0,1-.45,1.59-1.41,1.59s-1.41-.63-1.41-1.59v-.43h.65v.48c0,.56.24.9.74.9s.73-.33.73-1v-.48c0-.62-.26-.91-.79-.93h-.37v-.63h.41a.75.75,0,0,0,.75-.86v-.29c0-.64-.22-1-.73-1s-.74.35-.74.92v.32h-.65v-.29c0-1,.45-1.57,1.41-1.57S424.56,302.11,424.56,303.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,303.07c0-1,.48-1.57,1.44-1.57s1.44.61,1.44,1.57v3.24c0,1-.48,1.59-1.44,1.59s-1.44-.63-1.44-1.59Zm.69,3.29c0,.56.24.9.75.9s.74-.34.74-.9V303c0-.58-.23-.92-.74-.92s-.75.34-.75.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,325v.16a1.48,1.48,0,0,0,0,2.59v.49c0,1-.45,1.58-1.42,1.58s-1.41-.62-1.41-1.58v-.43h.66v.47c0,.57.23.91.73.91s.74-.34.74-1v-.49c0-.62-.26-.91-.79-.93h-.38v-.63h.41a.75.75,0,0,0,.76-.86V325c0-.64-.23-1-.74-1s-.73.35-.73.91v.32h-.66V325c0-1,.45-1.58,1.41-1.58S295,324.06,295,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,324.64a1.94,1.94,0,0,1-.87.27v-.57a1.09,1.09,0,0,0,1.08-.84h.48v6.28H297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.72,
    y1: 204.78,
    x2: 438.44,
    y2: 204.78,
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.78,
    y1: 161.92,
    x2: 283.78,
    y2: 330.15,
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.53,97c0,1.14,0,2.18,0,3.22a7.24,7.24,0,0,1-.11,2.73c-.34.74-1.3,1.2-2,1.78a1,1,0,0,0-.22.17.75.75,0,0,0-.15.36c0,.64,0,1.27,0,2,1.19-.35,2.28-.71,3.39-1a2.4,2.4,0,0,1,1.13,0c1.12.28,2.22.62,3.33.94.27-1.9.21-2-1.17-3.16-.33-.27-.66-.52-1-.8a.69.69,0,0,1-.28-.43c0-1.89,0-3.78,0-5.78l11.15,3.45c0-.75,0-1.4,0-2a1,1,0,0,0-.55-1c-3.34-2-6.66-4-10-5.95a1.08,1.08,0,0,1-.63-1.08c0-2.5,0-5,0-7.5a1.5,1.5,0,0,0-.87-1.52,1.46,1.46,0,0,0-2.07,1.51q0,3.8,0,7.57a1,1,0,0,1-.55,1c-3.38,2-6.75,4-10.11,6-.2.12-.48.32-.5.5,0,.81,0,1.63,0,2.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.53,97l-11.17,3.49c0-.91,0-1.73,0-2.54,0-.18.3-.38.5-.5,3.36-2,6.73-4,10.11-6a1,1,0,0,0,.55-1q0-3.78,0-7.57a1.46,1.46,0,0,1,2.07-1.51,1.5,1.5,0,0,1,.87,1.52c0,2.5,0,5,0,7.5a1.08,1.08,0,0,0,.63,1.08c3.34,2,6.66,4,10,5.95a1,1,0,0,1,.55,1c0,.64,0,1.29,0,2L147.47,97c0,2,0,3.89,0,5.78a.69.69,0,0,0,.28.43c.31.28.64.53,1,.8,1.38,1.11,1.44,1.26,1.17,3.16-1.11-.32-2.21-.66-3.33-.94a2.4,2.4,0,0,0-1.13,0c-1.11.29-2.2.65-3.39,1,0-.69,0-1.32,0-2a.75.75,0,0,1,.15-.36,1,1,0,0,1,.22-.17c.69-.58,1.65-1,2-1.78a7.24,7.24,0,0,0,.11-2.73C144.54,99.15,144.53,98.11,144.53,97Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.88,127.55c-9.06-6.71-21-6-28.17-1.51s-9.39,12.57-11.4,18.1c-4,11-12.59,17.54-21.89,23.89-9,6.17-20.69,15.21-14.52,27.54,2.79,5.59,6.28,9.43,1,18.51s-10.83,13.28-7,22,8.73,22.36,29.34,17.47,26.9-28.3,29-37,12.19-12.27,19.56-18.52,6.64-16.07,4.54-22.35c-1.6-4.82-3.4-11.68,2.11-17.14l.72.22s11.07-5,12.91-8.05S126.93,134.25,117.88,127.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.71,479.79s-7.37-4.86-8.37-6.73-3.59-11.42-3.59-11.42l-2.25-9.28-12.59-4.9-1.72,7.41a44.85,44.85,0,0,0-3.5,4.39c-1.4,2.09-1.14,6.17-.29,7l-2.11,11.37,2.27.43,2.87-9.25c.91.75,1.94,1.62,3.07,2.62,2.89,2.55,4,9.47,6.88,10s19,1.66,19.66.66S88.71,479.79,88.71,479.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,466.26l-2.11,11.37,2.27.43,2.87-9.25c.91.75,1.94,1.62,3.07,2.62,2.89,2.55,4,9.47,6.88,10s19,1.66,19.66.66-.33-2.31-.33-2.31a78.72,78.72,0,0,1-6.77-5l-.83.05c-4,.34-6.94.34-9.59-1.65s-11.33-18.31-11.33-18.31a44.85,44.85,0,0,0-3.5,4.39C55.29,461.35,55.55,465.43,56.4,466.26Z",
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84,479.79s-7.6-5.62-8.92-7.27S116.3,462,116.3,462l-4-9.25-13.22-2-.33,7.6a44.26,44.26,0,0,0-2.64,5c-1,2.31,0,6.28,1,6.94v11.56h2.31l1.13-9.61c1,.57,2.21,1.24,3.5,2,3.3,2,5.61,8.6,8.59,8.6s17.84.33,18.5-.67S130.84,479.79,130.84,479.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.14,470.21v11.56h2.31l1.13-9.61c1,.57,2.21,1.24,3.5,2,3.3,2,5.61,8.6,8.59,8.6s17.84.33,18.5-.67-.33-2.31-.33-2.31-3.72-2.75-6.41-5c-1.9.89-4.24,2-5.15,2.33a6.77,6.77,0,0,1-5.62-1c-1.32-1-14.87-17.85-14.87-17.85a44.26,44.26,0,0,0-2.64,5C95.15,465.58,96.15,469.55,97.14,470.21Z",
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,260.69s8.45,25.65,8.45,44.44-3.69,68.06-3.69,68.06l-13.05,80.75-14,.35s1.07-27.74-.37-49.41,1.71-37.13,1.71-37.13l-2,10.85c-.4,2.25-23.36,76.23-23.36,76.23L61.1,452.5l4.33-34.68L73,373.67s-8.79-52.28-11-59.51-1-25.31,2.61-33.26,12.47-17.52,12.47-17.52S112.17,265.52,122,260.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.79,374.67s5.5-13.76,5.5-19.26.69-50.92.69-50.92",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.28,
    y1: 312.83,
    x2: 116.23,
    y2: 305.18,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.43,185.11s12.18-5.39,18.28-5.39,14.39,9.58,16.5,11.46,14.67,23.93,15.84,29.79-3.4,72-3.4,72-15.71,5.09-27.43,4.62S66.54,296,66.54,296,65,234.08,62.65,220.25s-4.92-23-2.81-26.48S78.43,185.11,78.43,185.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.55 260.33 157.66 251.23 152.96 250.93 153.55 260.33",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66,242.42s1.18-7.93,2.35-9.39a34.69,34.69,0,0,1,5.87-5c2.06-1.46,2.94-6.16,4.11-3.52s1.17,4.41,0,5.29a17.19,17.19,0,0,0-2.64,2.93l3.81,5s-.58,6.17-4.1,9.69-5.58,4.7-7.34,4.7-12,3.81-12,3.81l.59-11.15S155.09,244.1,157.66,242.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.8 215.41 162.36 247.12 160.3 244.18 176.45 213.94 177.62 213.94 178.8 215.41",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.46,236.25s4.11-7.63,4.11-10.86-2.35-.58-2.64.88-5,8.81-5,8.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.87,235.08l-7.93-3.23s-1.76.88-.88,2.35,6.76,4.7,6.76,4.7l1.76,1.76S172.05,237.43,170.87,235.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,239l-6.66-2.71a1.34,1.34,0,0,0-1.6.45,1.38,1.38,0,0,0,0,1.6c.79,1.32,5.65,4.09,6.59,4.61a1.06,1.06,0,0,1,.29.22h0a1.35,1.35,0,0,0,2.3-.79,5.75,5.75,0,0,0-.12-2.5A1.38,1.38,0,0,0,169.75,239Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.25,242.66l-5.66-2.3a1.12,1.12,0,0,0-1.36.38,1.17,1.17,0,0,0,0,1.36c.68,1.13,4.81,3.47,5.61,3.92a1.1,1.1,0,0,1,.25.19h0a1.15,1.15,0,0,0,1.95-.68,4.93,4.93,0,0,0-.1-2.12A1.16,1.16,0,0,0,167.25,242.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.26 243.89 153.55 260.33 130.36 265.61 130.36 244.47 153.26 243.89",
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.61,191.93a74,74,0,0,1,11.08,27.51c2.85,16.08,2.64,93.82,2.64,93.82l12.18-3.9a283.38,283.38,0,0,1-4-38.22c-.29-12.28,1.66-24.86,1.66-31.33,0-16.44-3.51-25.81-6.37-32.95s-10.94-19-14.08-20.72a13.53,13.53,0,0,0-5.77-1.75Z",
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.43,185.11S92.53,199.43,96.1,213,98.27,317.8,98.27,317.8s-5.72.36-20.37.36a120.5,120.5,0,0,1-26.42-3s11-58.95,11-60-3.57-46.46-3.93-50.74-.71-6.44-.71-7.51S59.68,189,78.43,185.11Z",
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.63,182.55l-1.29,13.21S91.55,187.24,90,185.4a14.28,14.28,0,0,1-2.18-5.2l1.34-17.44s7.88,12.75,9.9,14.09S104.46,180.87,104.63,182.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22,172.52s8.78,8.17,12.72,10,4.23.6,7.56.6,4.24.91,4.24,3-.91,5.45-.91,7.26.61,6.36-8.17,5.45-17.25-6.66-20-9.69a14.41,14.41,0,0,1-3.33-6.35l2.73-3a17.14,17.14,0,0,1,.9-5.45C83.89,172.21,87.22,172.52,87.22,172.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,141.63s-17.94,10.57-23.31,13.08l-3,.84S88.87,150,87,151.19s-2.85,4.19-1.84,6.88a11.85,11.85,0,0,0,4,4.69s.17,8.05,1.35,11.07S104,184.06,106,184.39s3.86,0,4.87-1.84,7.37-9.39,10.22-19.79S122.24,143.31,119.05,141.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.03 158.57 115.53 168.3 110.16 167.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,168.3s1.17,1.5,6,3.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.62,157.4s1.34,2.85,6.2,1.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,161.25a2.91,2.91,0,0,0,3.52,1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,152.7a10.06,10.06,0,0,1,7.88,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,156.56c-.67-1.85-3.68-2.52-3.68-2.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.55 160.08 84.84 161.42 81.83 171.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.16,220.56c-1.07-.08-13.19-1.38-14.75-1.62s-3.93,1.15-4.83,2.22-10,11.39-12.15,13.86l-8.82,4.7,3.71,8.23,8.67-9.12c.68-.25,1.25-.47,1.57-.63,1.31-.66,2.78-3.44,2.78-3.44a21,21,0,0,0,3.85-.09c.9-.25,3.92-2.79,4.74-2.79s6.31-.09,7.21-2.79-7.45.25-7.45.25l3.43-7.05s6.88,1.47,10.16.65S159.22,220.64,158.16,220.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,221.16s4-2.58,4.43-2.4,4,6.06,4.23,6.52-3.15,3.31-3.69,3.77-.8.88-1.61.23a6.84,6.84,0,0,1-1.38-1.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,223.76s4.26-2.42,4.72-2.27,3.34,4.56,3.15,5.14-2,3.8-2.64,3.73a12,12,0,0,1-2.35-1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64,227.06a18,18,0,0,1,3.57-1.5c1.08-.15,2.49,2.5,3.48,3.78s2.32,2.24,1.36,2.82-3.22-1.46-3.8-1.65a7.39,7.39,0,0,1-1.65-1.19l-3,4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.84,193.77s-6.93,5.7-7.74,18C51.53,220.6,57.2,270,59,272.3s9.07,4.4,12.17,2.33,54.95-24.33,54.95-24.33l-4.25-13.12-42.16,9.59s-1.28-39.12-3.36-47.15-3.1-9.58-4.4-10.1",
    style: {
      fill: "#FF0A90",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNotFound);
export default __webpack_public_path__ + "static/media/calendar-not-found.fc1c17043d7c0f8ef3378d894061cc4f.svg";
export { ForwardRef as ReactComponent };